import React, { useContext } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { urlConfig } from '../../../config/urlConfig';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import { GlobalContext } from '../../../services/global/GlobalState';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';
import { useHistory } from 'react-router-dom';
import { Button, makeStyles } from '@material-ui/core';
import { FcGoogle } from 'react-icons/fc';

const useStyle = makeStyles((theme) => {
  return {
    Button: {
      display: 'flex',
      justifyContent: 'start',
    },
    googleIcon: {
      marginRight: 30,
    },
  };
});

export const LoginGoogle = ({ setFormError }) => {
  const { expirationDate } = useContext(GlobalContext);
  const { setUserData, setUserPreferTime } = useContext(AuthenticationContext);
  const history = useHistory();
  const classes = useStyle();

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      responseGoogle(tokenResponse);
    },
  });
  // useGoogleOneTapLogin({
  //   onSuccess: async (credentialResponse) => {
  //     console.log(credentialResponse);
  //     // googleLogin()
  //     responseGoogle(credentialResponse);
  //   },
  // });

  // const googleLogin = useGoogleLogin({
  //   onSuccess: async tokenResponse => {
  //     console.log(tokenResponse);
  //     // fetching userinfo can be done on the client or the server
  //     const userInfo = await axios
  //       .get('https://www.googleapis.com/oauth2/v3/userinfo', {
  //         headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
  //       })
  //       .then(res => res.data);

  //     console.log(userInfo);
  //   },
  // });

  const responseGoogle = (response) => {
    setUserData(null);
    setUserPreferTime(null);

    let decode = '';
    axios
      .post(urlConfig.login_with_google, {
        access_token: response.access_token,
      })
      .then((res) => {
        decode = jwt_decode(res.data.refresh_token);
        expirationDate(decode.exp);
        setUserData(res.data.user);
        Cookies.set('access_token', res.data.access_token, {
          expires: 365,
          secure: true,
          sameSite: 'none',
          path: '/',
        });
        Cookies.set('refresh_token', res.data.refresh_token, {
          expires: 365,
          secure: true,
          sameSite: 'none',
          path: '/',
        });
        history.push('/meetings');
      })
      .catch((err) => {
        err.response && setFormError(err.toString());
        setFormError(
          err.response &&
            err.response.data &&
            err.response.data.non_field_errors &&
            err.response.data.non_field_errors.toString()
        );
      });
  };

  return (
    <>
      <Button
        onClick={() => googleLogin()}
        variant='outlined'
        className={classes.Button}
        startIcon={<FcGoogle className={classes.googleIcon} />}
      >
        Continue with Google
      </Button>
    </>
  );
};
